import { Button } from "react-bootstrap";

import React from 'react';

const Row = ({ domain, onEdit, onRemove }) => {
    return (<tr>
        <td style={{ textAlign: 'left' }}>{domain.subdomain_domain}</td>
        <td style={{ textAlign: 'left' }}>{domain.domain}</td>
        <td>{domain.hour}</td>
        <td style={{ textAlign: 'left' }}>{domain.type}</td>
        <td>{domain.flagged}</td>
        <td>{domain.flaggedAt}</td>
        <td>{domain.virusTotal}</td>
        <td>{domain.sucuri}</td>
        <td>{domain.norton}</td>
        <td>{domain.avast}</td>
        <td>{domain.google}</td>
        <td>{domain.note}</td>
        <td style={{ width: '1%', whiteSpace: 'nowrap' }}>
            <Button style={{ marginRight: '5px' }} bsStyle="primary" onClick={() => onEdit(domain)}>Edit</Button>

            <Button bsStyle="danger" onClick={() => onRemove(domain.id)}>Remove</Button>
        </td>
    </tr>);

};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/Domains/components/Table/components/Row/index.js